import { render, staticRenderFns } from "./TemplatePackageForm.vue?vue&type=template&id=71f6fa7a&scoped=true"
import script from "./TemplatePackageForm.vue?vue&type=script&lang=js"
export * from "./TemplatePackageForm.vue?vue&type=script&lang=js"
import style0 from "./TemplatePackageForm.vue?vue&type=style&index=0&id=71f6fa7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f6fa7a",
  null
  
)

export default component.exports